import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { TmaisRaffleData, TmaisRaffleResponse } from "../types/tmaisRaffles.type";

const useTmaisRaffle: (id: string) => UseQueryResult<TmaisRaffleData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<TmaisRaffleResponse, unknown, TmaisRaffleData>({
    queryKey: ['tmaisRaffle', id],
    queryFn: () => privateAxios.get(`/tmais/raffles/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useTmaisRaffle;
